const isNumber = (value: any) => {
  return !isNaN(value)
}

const removeNonDigits = (value: any): string => {
  return value.toString().replace(/\D/g, '')
}

export { isNumber, removeNonDigits }
